import React from "react";
import Loader from "../components/Utils/Loader";
import Box from "@mui/material/Box";
import { Typography } from "@mui/material";
import PageContainer from "./PageContainer";
const Guide = () => {
  const basketballStats = [
    {
      name: "X-Factor",
      abbr: "OVR",
      definition:
        "This is a rating that based on Production/Efficiency, the X-Factor score is a make up of shooting (True Shooting %), rebounding (offensive & defensive rebound rate), assist/T/O rate versus minutes played & strength of opponent.",
      background: "#6a0004bf",
      color: "#fff",
    },
    {
      name: "True Shooting Percentage",
      abbr: "TS%",
      definition:
        "A measure of scoring efficiency that accounts for field goals, three-pointers, and free throws, providing a more accurate assessment of a player’s shooting effectiveness.",
    },
    {
      name: "Effective Field Goal Percentage",
      abbr: "eFG%",
      definition:
        "Adjusts field goal percentage to account for the added value of three-point shots, giving more weight to three-pointers made.",
    },
    {
      name: "Points Per Possession",
      abbr: "PPP",
      definition:
        "The average number of points a team scores per offensive possession, used to evaluate offensive efficiency.",
    },
    {
      name: "Usage Percentage",
      abbr: "USG%",
      definition:
        "Estimates the percentage of team plays a player is involved in while on the court, showing how much responsibility they have in the offense.",
    },
    {
      name: "Possessions",
      abbr: "",
      definition:
        "The total number of offensive opportunities a team has, including field goal attempts, free throws, and turnovers.",
    },
    {
      name: "Player Efficiency Rating",
      abbr: "PER",
      definition:
        "A composite stat that evaluates a player’s overall performance and productivity based on various statistical contributions per minute.",
    },
    {
      name: "Offensive Rating",
      abbr: "ORtg",
      definition:
        "The number of points a player or team produces per 100 possessions, reflecting offensive effectiveness.",
    },
    {
      name: "Defensive Rating",
      abbr: "DRtg",
      definition:
        "The number of points a player or team allows per 100 possessions, measuring defensive performance.",
    },
    {
      name: "Free Throw Rate",
      abbr: "FTr",
      definition:
        "The ratio of free throw attempts to field goal attempts, showing how frequently a player or team gets to the free-throw line.",
    },
    {
      name: "Offensive Rebounding Percentage",
      abbr: "OREB%",
      definition:
        "The percentage of available offensive rebounds a player secures while on the court.",
    },
    {
      name: "Defensive Rebounding Percentage",
      abbr: "DREB%",
      definition:
        "The percentage of available defensive rebounds a player collects while in the game.",
    },
    {
      name: "Total Rebounding Percentage",
      abbr: "TRB%",
      definition:
        "The percentage of all available rebounds, offensive and defensive, that a player grabs while on the court.",
    },
    {
      name: "Assist Ratio",
      abbr: "",
      definition:
        "The percentage of a player’s possessions that result in an assist, indicating their playmaking ability.",
    },
    {
      name: "Assist-to-Turnover Ratio",
      abbr: "AST/TO",
      definition:
        "Compares the number of assists to turnovers, highlighting how effectively a player distributes the ball without committing mistakes.",
    },
    {
      name: "Assists per Team Possession",
      abbr: "",
      definition:
        "Measures how often a player creates scoring opportunities for teammates relative to team possessions.",
    },
    {
      name: "Steal Percentage",
      abbr: "STL%",
      definition:
        "Estimates the percentage of opponent possessions where a player records a steal, reflecting defensive disruption.",
    },
    {
      name: "Block Percentage",
      abbr: "BLK%",
      definition:
        "The percentage of opponent two-point field goal attempts that a player blocks, showcasing rim protection.",
    },
    {
      name: "Turnover Percentage",
      abbr: "TOV%",
      definition:
        "The percentage of a player’s possessions that end in a turnover, indicating ball security.",
    },
    {
      name: "Assisted FG%",
      abbr: "",
      definition:
        "The percentage of made field goals that were assisted, measuring teamwork and ball movement.",
    },
    {
      name: "Turnover Ratio",
      abbr: "",
      definition:
        "The number of turnovers committed per 100 possessions, used to evaluate a player’s ball-handling reliability.",
    },
    {
      name: "Plus/Minus",
      abbr: "+/-",
      definition:
        "The point differential when a player is on the court, showing their impact on team performance relative to opponents.",
    },
  ];

  return (
    <PageContainer>
      <div className="guide-container">
        <Typography variant="h4" sx={{ mb: 4, mt: 4 }}>
          XSM Glossary
        </Typography>
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))",
            gap: "20px",
            width: "100%",
            padding: "20px 0",
          }}
        >
          {basketballStats.map((stat, index) => (
            <Box
              key={index}
              sx={{
                backgroundColor: stat.background
                  ? stat.background
                  : "rgba(32, 33, 36, 0.9)",
                borderRadius: "12px",
                padding: "20px",
                transition: "transform 0.2s",
                "&:hover": {
                  transform: "translateY(-4px)",
                },
              }}
            >
              <Typography
                variant="h6"
                sx={{
                  color: "#fff",
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  mb: 1,
                }}
              >
                {stat.name}
                {stat.abbr && (
                  <Typography
                    component="span"
                    sx={{
                      color: stat.color ? stat.color : "#8b8b8b",
                      fontSize: "0.9em",
                    }}
                  >
                    ({stat.abbr})
                  </Typography>
                )}
              </Typography>
              <Typography
                sx={{
                  color: stat.color ? stat.color : "rgba(255, 255, 255, 0.7)",
                  fontSize: "0.9rem",
                  lineHeight: 1.5,
                }}
              >
                {stat.definition}
              </Typography>
            </Box>
          ))}
        </Box>
      </div>
    </PageContainer>
  );
};

export default Guide;
